/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delete_Confirm_CancelInputs */

const he_account_delete_confirm_cancel = /** @type {(inputs: Account_Delete_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ביטול`)
};

const en_account_delete_confirm_cancel = /** @type {(inputs: Account_Delete_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Account_Delete_Confirm_CancelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delete_confirm_cancel = /** @type {((inputs?: Account_Delete_Confirm_CancelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delete_Confirm_CancelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delete_confirm_cancel(inputs)
	return en_account_delete_confirm_cancel(inputs)
});